import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Brand from "@/components/Brand";
import Spinner from "@/components/Spinner";

export default function StudentLogin() {
  const { loginStudent } = useAuth();
  const navigate = useNavigate();

  const [studentCode, setStudentCode] = useState("");
  const [dob, setDob] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await loginStudent(studentCode.trim().toUpperCase(), dob);
    setSubmitting(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    navigate("/student", { replace: true });
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex flex-col items-center justify-center p-6">
      <Brand size="lg" className="mb-6" />
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-xl p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900 mb-1">
          Student Login
        </h1>
        <p className="text-sm text-slate-500 mb-6">
          Use your Student Code and date of birth.
        </p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Student Code
            </label>
            <input
              type="text"
              required
              autoFocus
              placeholder="e.g. MM000127"
              data-testid="student-login-code"
              className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-slate-500 font-mono uppercase"
              value={studentCode}
              onChange={(e) => setStudentCode(e.target.value)}
            />
            <p className="mt-1 text-xs text-slate-500">
              Your Student Code is provided by your school.
            </p>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Date of Birth
            </label>
            <input
              type="date"
              required
              data-testid="student-login-dob"
              className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-slate-500"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
            />
          </div>

          {error ? (
            <p data-testid="student-login-error" className="text-sm text-red-600">
              {error}
            </p>
          ) : null}

          <button
            type="submit"
            disabled={submitting}
            data-testid="student-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-indigo-700 text-white text-sm font-medium py-2 hover:bg-indigo-800 disabled:opacity-60 transition"
          >
            {submitting ? <Spinner className="h-4 w-4" /> : null}
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="mt-6 text-xs text-slate-500">
          <Link to="/" className="hover:text-slate-900">← Home</Link>
        </div>
      </div>
    </div>
  );
}
